import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditSearchpageLanguage extends Component {

    state = {
        searchpageLanguage: this.props.searchpageLanguage,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { searchpageLanguage = 0 } = this.state

        return (
            <Modal
                narrow
                extraClassName="EditSearchpageLanguage"
                onCancel={this.props.onClose}
                onSave={this.onSave}
                saveText="Save"
                mode="edit"
                title="Searchpage Language">
                <Form>
                    <div>
                        { ['Sv', 'En', 'Fr'].map((text, value) => (
                            <label key={value} className="radio">
                                <input
                                    type="radio"
                                    name="searchpageLanguage"
                                    value={value}
                                    checked={searchpageLanguage === value}
                                    onChange={e => this.setState({ searchpageLanguage: value })} />
                                {text}
                            </label>
                        ))}
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default EditSearchpageLanguage



// WEBPACK FOOTER //
// ./src/components/LBUs/EditSearchpageLanguage.js